define(["exports", "./include-config", "./override-configuration", "./respec-ready", "./post-process", "./pre-process", "./pubsubhub", "./utils"], function (_exports, _includeConfig, _overrideConfiguration, _respecReady, _postProcess, _preProcess, _pubsubhub, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.runAll = runAll;
  _exports.name = void 0;
  // @ts-check
  // Module core/base-runner
  // The module in charge of running the whole processing pipeline.
  const name = "core/base-runner";
  _exports.name = name;
  const canMeasure = performance.mark && performance.measure;

  function toRunnable(plug) {
    const name = plug.name || "";

    if (!name) {
      console.warn("Plugin lacks name:", plug);
    }

    return config => {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        const timerId = setTimeout(() => {
          const msg = "Plugin ".concat(name, " took too long.");
          console.error(msg, plug);
          reject(new Error(msg));
        }, 15000);

        if (canMeasure) {
          performance.mark("".concat(name, "-start"));
        }

        try {
          if (plug.run.length <= 1) {
            await plug.run(config);
            resolve();
          } else {
            console.warn("Plugin ".concat(name, " uses a deprecated callback signature. Return a Promise instead. Read more at: https://github.com/w3c/respec/wiki/Developers-Guide#plugins"));
            plug.run(config, document, resolve);
          }
        } catch (err) {
          reject(err);
        } finally {
          clearTimeout(timerId);
        }

        if (canMeasure) {
          performance.mark("".concat(name, "-end"));
          performance.measure(name, "".concat(name, "-start"), "".concat(name, "-end"));
        }
      });
    };
  }

  async function runAll(plugs) {
    (0, _pubsubhub.pub)("start-all", respecConfig);

    if (canMeasure) {
      performance.mark("".concat(name, "-start"));
    }

    await _preProcess.done;
    const runnables = plugs.filter(plug => plug && plug.run).map(toRunnable);

    for (const task of runnables) {
      try {
        await task(respecConfig);
      } catch (err) {
        console.error(err);
      }
    }

    (0, _pubsubhub.pub)("plugins-done", respecConfig);
    await _postProcess.done;
    (0, _pubsubhub.pub)("end-all", respecConfig);
    (0, _utils.removeReSpec)(document);

    if (canMeasure) {
      performance.mark("".concat(name, "-end"));
      performance.measure(name, "".concat(name, "-start"), "".concat(name, "-end"));
    }
  }
});
//# sourceMappingURL=base-runner.js.map